import React, { useState } from "react";

import Link from "core/Link";
import {
    FormButtonBodyText,
    OptionalBodyText,
    PlusMinusButton,
    ReceiptInfoHelpIcon,
    ReceiptInfoTextWrapper,
    VatContainer,
    VatGrid
} from "core/CheckoutForm/styles";
import Minus from "core/ReusableIcons/Minus";
import colors from "core/colors";
import SrOnly from "core/SrOnly";
import Add from "core/ReusableIcons/Add";
import FormTextArea from "core/FormTextArea";
import { convertPxToRem } from "frontend/components/helpers";
import Tooltip from "core/Tooltip";
import { useUpdateBillingInfo } from "frontend/context/CheckoutContext";

const VatInput = () => {
    const [showReceiptInfoField, setShowReceiptInfoField] = useState(false);

    const { receiptInfo, setReceiptInfo } = useUpdateBillingInfo();

    const receiptInfoField = (
        <FormTextArea
            placeholderText="Vat number, billing information (optional)"
            labelText="Vat number, billing information (optional)"
            onChange={value => setReceiptInfo(value)}
            value={receiptInfo}
            isDisabled={false}
            height={convertPxToRem({ px: 54 })}
        />
    );

    const handleVatOnclick = e => {
        e.preventDefault();
        setShowReceiptInfoField(!showReceiptInfoField);
    };

    const receiptInfoButtons = (
        <ReceiptInfoTextWrapper>
            <Link
                styleType="primary"
                size="lg"
                onClick={handleVatOnclick}
                isButton
            >
                Add billing information
            </Link>

            <OptionalBodyText
                type="span"
                size="lg"
                copyColor={colors.secondary.oolong}
            >
                (optional)
            </OptionalBodyText>

            <Tooltip
                clickToOpen
                message="This displays VAT, address, or job number on your invoices for tax purposes. You can change it later."
            >
                <ReceiptInfoHelpIcon />
            </Tooltip>
        </ReceiptInfoTextWrapper>
    );

    return (
        <VatGrid item sm={12} md={12} lg={12}>
            <VatContainer>
                <PlusMinusButton
                    onClick={handleVatOnclick}
                    showReceiptInfoField={showReceiptInfoField}
                >
                    {showReceiptInfoField ? (
                        <>
                            <Minus fillColor={colors.secondary.oolong} />
                            <SrOnly>Close VAT information form field</SrOnly>
                        </>
                    ) : (
                        <>
                            <Add
                                size="sm"
                                fillColor={colors.secondary.oolong}
                            />
                            <SrOnly>Open VAT information form field</SrOnly>
                        </>
                    )}
                </PlusMinusButton>

                {showReceiptInfoField ? receiptInfoField : receiptInfoButtons}
            </VatContainer>
        </VatGrid>
    );
};

export default VatInput;
